/** Product landing hosts (LAND5 v2). Kept apart from the registry so the station imports no landing copy. */
export const LANDING_HOST = Object.freeze({ CALCUL: 'calcul.neoprof.fr' });
export const LANDING_HOSTS = Object.freeze(Object.values(LANDING_HOST));

/** Hosts where preview aliases (`/l/…`, `/h/…`) resolve: local dev and Vercel previews. */
export const PREVIEW_LOCAL_HOSTS = Object.freeze(['localhost', '127.0.0.1', '[::1]', '::1']);
export const isPreviewHost = (host) => PREVIEW_LOCAL_HOSTS.includes(host) || host.endsWith('.vercel.app');
export const absoluteHostUrl = (host, path = '/') => new URL(path, `https://${host}`).href;
